// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divmergeform {
  background-color: transparent;
  margin-top: 5px;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/speakerslist/commonmergeform/commonmergeform.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".divmergeform {\n  background-color: transparent;\n  margin-top: 5px;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
